import axios from 'axios'
import CryptoJS from 'crypto-js'
import sha1 from 'sha1'
import { SMS_API_BASE, PRODUCT_ID, PRODUCT_KEY, APP_VERSION } from '@/config/env';

const DEVICE_ID_STORAGE_KEY = 'DEVICE_ID';

function encodeUrl(data) {
  let encoded = data.replace(/\+/g, '-');
  encoded = encoded.replace(/\//g, '_');
  encoded = encoded.replace(/=/g, ',');
  return encoded;
}

function encrypt(plainTextValue, keyValue) {
  const plainText = CryptoJS.enc.Utf8.parse(plainTextValue);
  const key = CryptoJS.enc.Utf8.parse(keyValue);
  const aes = CryptoJS.algo.AES.createEncryptor(key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
    iv: key,
  });
  const encrypted = aes.finalize(plainText);
  return encodeUrl(CryptoJS.enc.Base64.stringify(encrypted));
}

function detectDeviceOS(userAgent) {
  const ua = userAgent.toLowerCase();

  if (/android/.test(ua)) return 'ANDROID';
  if (/iphone|ipad|ipod/.test(ua)) return 'IOS';
  if (/windows/.test(ua)) return 'WINDOWS';
  if (/mac os x|macintosh/.test(ua)) return 'MACOS';
  if (/linux/.test(ua)) return 'LINUX';
  // Backend cannot accept UNKNOWN; default to a safe desktop value.
  return 'WINDOWS';
}

function detectDeviceType(userAgent) {
  const ua = userAgent.toLowerCase();

  if (/ipad|tablet|playbook|silk/.test(ua)) return 'TABLET';
  if (/mobi|android|iphone|ipod|phone/.test(ua)) return 'MOBILE';
  return 'PC';
}

function generateFallbackId() {
  return `dev_${Math.random().toString(36).slice(2, 11)}_${Date.now().toString(36)}`;
}

function getOrCreateDeviceId() {
  if (typeof window === 'undefined') {
    return generateFallbackId();
  }

  const existingDeviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (existingDeviceId) {
    return existingDeviceId;
  }

  const newDeviceId = typeof window.crypto !== 'undefined' && typeof window.crypto.randomUUID === 'function'
    ? window.crypto.randomUUID()
    : generateFallbackId();

  window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, newDeviceId);
  return newDeviceId;
}

function buildEncryptedDeviceInfo() {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const deviceid = getOrCreateDeviceId();
  const payload = {
    deviceid,
    devicetype: detectDeviceType(userAgent), // <STB|MOBILE|TABLET|TV|CONSOLE|PC>
    deviceos: detectDeviceOS(userAgent), // <IOS|ANDROID|WINDOWS|LINUX|...>
    productid: PRODUCT_ID,
    timestamp: Math.floor(Date.now() / 1000),
    appversion: APP_VERSION,
  };

  const payloadString = JSON.stringify(payload);
  return {
    hash: sha1(payloadString),
    enc: encrypt(payloadString, PRODUCT_KEY),
    productid: PRODUCT_ID,
  };
}

export async function registerDevice() {
  try {
    const { hash, enc, productid } = buildEncryptedDeviceInfo();
    const deviceApiUrl = `${SMS_API_BASE}/admin/v1/device/register/${productid}?hash=${hash}&productid=${productid}`;

    const response = await axios.post(deviceApiUrl, enc, {
      headers: {
        'Content-Type': 'text/plain'
      },
    })

    const accessToken = response.data.success
    if (accessToken) {
      localStorage.setItem('DEVICE_REG_TOKEN', accessToken)
      console.log('✅ Device registered and token stored.')
    } else {
      console.error('❌ No token found in device registration response.')
    }
  } catch (error) {
    console.error('❌ Device registration failed:', error)
  }
}
